import { TFunction } from 'i18next';
import { useLang } from 'hooks/lang';

import { Column, Row, Button, Tabs } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';
import { PackagePlusIcon } from 'components/Icons';

import { ActivePackages } from './Active';
import { CanceledPackages } from './Canceled';
import { DonePackages } from './Done';

import { useUrlStateV2 } from 'hooks';

import { quickSwitch } from 'utils/conditions';
import { listGet } from 'utils/array';

const tabs = [
  {
    getLabel: (t: TFunction) => t('active')!,
    value: 'active',
  },
  {
    getLabel: (t: TFunction) => t('done')!,
    value: 'done',
  },
  {
    getLabel: (t: TFunction) => t('canceled')!,
    value: 'canceled',
  },
];

function Packages(): JSX.Element {
  const { t } = useLang();

  const [{ tab }, setQuery] = useUrlStateV2({
    tab: {
      defaultValue: 'active',
      validate: (value) => !!listGet(tabs, value, 'value'),
    },
  });

  return (
    <Column>
      <Row justifyContent="space-between">
        <Column gap="2">
          <h5 className="flex items-center gap-2 text-3xl font-medium leading-none text-primary phone:text-xl">
            <GoBackButton to="invoiceHome" />

            {t('packages')}
          </h5>

          <Tabs value={tab} onTabChange={(tab) => setQuery({ tab })} tabs={tabs} />
        </Column>

        <Button variant="outlined" to="createPackage" className="phone:self-start">
          <PackagePlusIcon />
          <span className="phone:hidden">{t('create-new')}</span>
        </Button>
      </Row>

      {quickSwitch(tab, [
        { is: 'active', then: () => <ActivePackages key={tab} /> },
        { is: 'canceled', then: () => <CanceledPackages key={tab} /> },
        { is: 'done', then: () => <DonePackages key={tab} /> },
      ])}
    </Column>
  );
}

export default Packages;
